"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positionOnAxis = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactUseportal = _interopRequireDefault(require("react-useportal"));

var _reactUseRealDimensions = _interopRequireDefault(require("react-use-real-dimensions"));

var _propTypes = _interopRequireDefault(require("prop-types"));

// $FlowFixMe
// $FlowFixMe
// $FlowFixMe
// $FlowFixMe
var FloatyBox = function FloatyBox(props) {
  var getSideAlignLetter = function getSideAlignLetter(str) {
    str = str[0];
    if (str === 'u') return 't';
    if (str === 'd') return 'b';
    return str;
  };

  var isControlled = typeof props.isOpen === 'boolean'; // set up element measurement

  var _useRealDimensions = (0, _reactUseRealDimensions.default)(),
      _useRealDimensions2 = (0, _slicedToArray2.default)(_useRealDimensions, 2),
      bubbleRef = _useRealDimensions2[0],
      dimensions = _useRealDimensions2[1];

  var bubbleWidth = dimensions.width;
  var bubbleHeight = dimensions.height; // use the usePortal hook for React portal, state management,
  // using outslide clicks and esc to close etc.

  var portal = (0, _reactUseportal.default)({
    // these options must be false when controlled
    // or else usePortal()s state can become out of sync
    closeOnOutsideClick: isControlled ? false : props.closeOnOutsideClick,
    closeOnEsc: isControlled ? false : props.closeOnEsc
  }); // positioning

  var _useWindowDimensions = useWindowDimensions(),
      _useWindowDimensions2 = (0, _slicedToArray2.default)(_useWindowDimensions, 2),
      windowWidth = _useWindowDimensions2[0],
      windowHeight = _useWindowDimensions2[1];

  var updateElementRectWhenChanged = [windowWidth, windowHeight, portal.isOpen, props.open === 'always'].concat((0, _toConsumableArray2.default)(props.forceUpdate));

  var _useElementRect = useElementRect(portal.ref, updateElementRectWhenChanged),
      _useElementRect2 = (0, _slicedToArray2.default)(_useElementRect, 1),
      anchorRect = _useElementRect2[0];

  var flip = props.flip,
      slide = props.slide,
      trap = props.trap,
      gap = props.gap,
      edge = props.edge,
      tailSize = props.tailSize;
  var side = getSideAlignLetter(props.side);
  var align = getSideAlignLetter(props.align);
  var alignInner = getSideAlignLetter(props.alignInner);
  var params = {
    bubbleWidth: bubbleWidth,
    bubbleHeight: bubbleHeight,
    windowWidth: windowWidth,
    windowHeight: windowHeight,
    anchorTop: anchorRect ? anchorRect.top : 0,
    anchorBottom: anchorRect ? anchorRect.bottom : 0,
    anchorLeft: anchorRect ? anchorRect.left : 0,
    anchorRight: anchorRect ? anchorRect.right : 0,
    side: side,
    align: align,
    alignInner: alignInner,
    gap: gap,
    edge: edge,
    tailSize: tailSize,
    flip: flip,
    slide: slide,
    trap: trap
  };

  var _useMemo = (0, _react.useMemo)(function () {
    return getFloatyStyle(params);
  }, Object.keys(params).map(function (key) {
    return params[key];
  }).concat(props.forceUpdate)),
      bubbleStyle = _useMemo.bubbleStyle,
      tailStyle = _useMemo.tailStyle,
      realSide = _useMemo.realSide; // floatybox can be controlled
  // if so, keep usePortal's state in sync


  useControlledPortal(portal, props.isOpen);
  var controlledHandlers = {
    isOpen: props.isOpen,
    openPortal: function openPortal() {
      return props.onChange && props.onChange(true);
    },
    closePortal: function closePortal() {
      return props.onChange && props.onChange(false);
    }
  }; // create React elements

  var Wrap = props.wrap;
  var handlers = createHandlers(props.open, isControlled ? controlledHandlers : portal);
  var Portal = portal.Portal;
  var renderedBubble = (0, _react.useMemo)(function () {
    return props.bubble({
      close: function close() {
        return portal.closePortal();
      },
      isOpen: portal.isOpen,
      tailProps: {
        side: realSide,
        size: tailSize,
        style: tailStyle
      }
    });
  }, [props.bubble, realSide, tailSize, tailStyle, portal.isOpen, portal.closePortal]);
  (0, _react.useEffect)(function () {
    portal.portalRef.current.style.cssText = "\n            z-index: ".concat(props.zIndex.toFixed(), ";\n            position: fixed;\n            width: 200%;\n            height: 200%;\n            top: 0;\n            left: 0;\n            pointer-events: none;\n        ");
  }, []);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Wrap, (0, _extends2.default)({}, handlers, {
    ref: portal.ref
  }), props.children), (portal.isOpen || props.open === 'always') && _react.default.createElement(Portal, null, _react.default.createElement("div", {
    style: bubbleStyle,
    ref: bubbleRef
  }, renderedBubble)));
};

FloatyBox.propTypes = {
  // components
  children: function children() {
    return (typeof _propTypes.default.node === "function" ? _propTypes.default.node.isRequired ? _propTypes.default.node.isRequired : _propTypes.default.node : _propTypes.default.shape(_propTypes.default.node).isRequired).apply(this, arguments);
  },
  wrap: _propTypes.default.any,
  // element thunks
  bubble: _propTypes.default.func.isRequired,
  // positioning
  side: _propTypes.default.oneOf(["top", "bottom", "left", "right"]),
  align: _propTypes.default.oneOf(["up", "down", "left", "right", "center"]),
  alignInner: _propTypes.default.oneOf(["up", "down", "left", "right", "center"]),
  flip: _propTypes.default.bool,
  slide: _propTypes.default.bool,
  trap: _propTypes.default.bool,
  gap: _propTypes.default.number,
  edge: _propTypes.default.number,
  zIndex: _propTypes.default.number,
  tailSize: _propTypes.default.number,
  // interaction
  open: _propTypes.default.oneOf(["click", "hover", "always"]),
  closeOnOutsideClick: _propTypes.default.bool,
  closeOnEsc: _propTypes.default.bool,
  // update control
  forceUpdate: _propTypes.default.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  }),
  // controlled state
  isOpen: _propTypes.default.bool,
  onChange: _propTypes.default.func
};
FloatyBox.defaultProps = {
  side: 'top',
  align: 'center',
  alignInner: 'center',
  flip: false,
  slide: false,
  trap: false,
  gap: 0,
  edge: 0,
  wrap: 'span',
  zIndex: 100,
  tailSize: 0,
  forceUpdate: []
};
var _default = FloatyBox; //
// positioning maths
//

exports.default = _default;

var lerp = function lerp(a, b, amount) {
  return a + (b - a) * amount;
};

var clamp = function clamp(x, min, max) {
  return Math.min(Math.max(x, min), max);
};

var X_AXIS = {
  l: 0,
  c: 0.5,
  r: 1
};
var Y_AXIS = {
  t: 0,
  c: 0.5,
  b: 1
};
var FLIP_AXIS = {
  l: 'r',
  r: 'l',
  t: 'b',
  b: 't'
};

var getFloatyStyle = function getFloatyStyle(params) {
  var bubbleWidth = params.bubbleWidth,
      bubbleHeight = params.bubbleHeight,
      windowWidth = params.windowWidth,
      windowHeight = params.windowHeight,
      anchorTop = params.anchorTop,
      anchorBottom = params.anchorBottom,
      anchorLeft = params.anchorLeft,
      anchorRight = params.anchorRight,
      side = params.side,
      align = params.align,
      alignInner = params.alignInner,
      gap = params.gap,
      edge = params.edge,
      tailSize = params.tailSize,
      flip = params.flip,
      slide = params.slide,
      trap = params.trap; // bubble measurement not yet taken, return blank styles for measuring the bubble with

  if (bubbleHeight === undefined || bubbleWidth === undefined) {
    return {
      bubbleStyle: {},
      tailStyle: {
        display: 'none'
      }
    };
  }

  var xResult = positionOnAxis(side, align, alignInner, gap, edge, tailSize, X_AXIS, anchorLeft, anchorRight, bubbleWidth, windowWidth, flip, slide, trap);
  var yResult = positionOnAxis(side, align, alignInner, gap, edge, tailSize, Y_AXIS, anchorTop, anchorBottom, bubbleHeight, windowHeight, flip, slide, trap);
  return {
    bubbleStyle: {
      position: 'absolute',
      left: "".concat(Math.floor(xResult.pos).toFixed(), "px"),
      top: "".concat(Math.floor(yResult.pos).toFixed(), "px"),
      pointerEvents: 'auto'
    },
    tailStyle: {
      position: 'absolute',
      display: xResult.tailHide || yResult.tailHide ? 'none' : 'block',
      left: "".concat(xResult.tail.toFixed(), "px"),
      top: "".concat(yResult.tail.toFixed(), "px")
    },
    // $FlowFixMe - one of xResult.side or yResult.side will be a string
    realSide: xResult.side || yResult.side
  };
};

// exported only for tests
// do not use this directly,
// this is not part of the public API
// and is liable to change at any time
var positionOnAxis = function positionOnAxis(side, align, alignInner, gap, edge, tailSize, axis, anchorStart, anchorEnd, bubbleSize, windowSize, flip, slide, trap) {
  // if this is the main axis a.k.a. props.side
  // then do this bit
  if (axis[side] !== undefined) {
    // set position to the preferred side of the bubble
    var startPos = anchorStart - bubbleSize - gap;
    var endPos = anchorEnd + gap;

    var _pos = lerp(startPos, endPos, axis[side]); // if using flip, flip side if there isnt enough room on preferred side


    if (flip && (_pos < edge || _pos + bubbleSize > windowSize - edge)) {
      _pos = lerp(endPos, startPos, axis[side]);
    } // if using trap, clamp position so the bubble doesnt leave screen edges


    if (trap) {
      _pos = clamp(_pos, edge, windowSize - bubbleSize - edge);
    } // if new positioning of bubble has made it flip sides, tell the tail to swap sides


    var midBubble = _pos + bubbleSize * 0.5;
    var midAnchor = anchorStart + (anchorEnd - anchorStart) * 0.5;

    if (midBubble > midAnchor === (axis[side] === 0)) {
      side = FLIP_AXIS[side];
    } // position tail


    var _tail = lerp(bubbleSize - 1, -tailSize + 1, axis[side]);

    return {
      pos: _pos,
      tail: _tail,
      tailHide: false,
      side: side
    };
  } // ...or else this is the cross axis a.k.a. props.align


  var halfTail = tailSize * 0.5;
  var innerPos = lerp(anchorStart + halfTail, anchorEnd - halfTail, axis[alignInner]);
  var minPos = innerPos - bubbleSize + halfTail;
  var maxPos = innerPos - halfTail;
  var pos = lerp(minPos, maxPos, axis[align]); // if using slide, slide bubble along if too close to screen edges

  var tailHide = false;

  if (slide || trap) {
    pos = clamp(pos, edge, windowSize - bubbleSize - edge); // find out if the tail has detached
    // and if trap is used, hide the tail
    // or if trap is not used, move the bubble back so its attached again

    if (pos < minPos || pos > maxPos) {
      if (trap) {
        tailHide = true;
      } else {
        pos = clamp(pos, minPos, maxPos);
      }
    }
  } // position tail


  var tail = innerPos - halfTail - pos;
  return {
    pos: pos,
    tail: tail,
    tailHide: tailHide,
    side: undefined
  };
}; //
// hooks and utils
//
// floatybox can be controlled
// if so, keep usePortal's state in sync


exports.positionOnAxis = positionOnAxis;

var useControlledPortal = function useControlledPortal(portal, isOpen) {
  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      lastPropsIsOpen = _useState2[0],
      setLastPropsIsOpen = _useState2[1];

  (0, _react.useEffect)(function () {
    if (isOpen) {
      portal.openPortal();
    }
  }, []);

  if (portal.ref.current && lastPropsIsOpen !== isOpen) {
    isOpen ? portal.openPortal() : portal.closePortal();
    setLastPropsIsOpen(isOpen);
  }
}; // floatybox needs to know window dimensions as they change
// so do that, and do it whenever the size changes


var useWindowDimensions = function useWindowDimensions() {
  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      windowDimensions = _useState4[0],
      setWindowDimensions = _useState4[1];

  var update = function update() {
    window.requestAnimationFrame(function () {
      // $FlowFixMe - this is fine, go away flow
      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; // $FlowFixMe - this is fine, go away flow

      var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      setWindowDimensions([windowWidth, windowHeight]);
    });
  };

  (0, _react.useLayoutEffect)(function () {
    update();

    var onResize = function onResize() {
      return update();
    };

    window.addEventListener("resize", onResize);
    return function () {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  return windowDimensions;
}; // floatybox needs to keep track of elements size relative to window
// so calculate that, and recalculate it on scroll


var useElementRect = function useElementRect(ref, updateWhenChanged) {
  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      rect = _useState6[0],
      setRect = _useState6[1];

  var update = function update() {
    window.requestAnimationFrame(function () {
      setRect(ref.current && ref.current.getBoundingClientRect());
    });
  };

  (0, _react.useLayoutEffect)(function () {
    var onScroll = function onScroll() {
      return update();
    };

    window.addEventListener("scroll", onScroll);
    return function () {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  (0, _react.useLayoutEffect)(function () {
    update();
  }, [ref.current].concat((0, _toConsumableArray2.default)(updateWhenChanged)));
  return [rect];
}; // creates event handlers to add to the anchor element
// based on the type of interaction


var createHandlers = function createHandlers(open, portal) {
  var openPortal = portal.openPortal,
      closePortal = portal.closePortal,
      isOpen = portal.isOpen;

  if (open === 'click') {
    return {
      onClick: isOpen ? closePortal : openPortal
    };
  }

  if (open === 'hover') {
    return {
      onMouseOver: openPortal,
      onMouseOut: closePortal
    };
  }

  return {};
};